<template>
  <div class="page-home">
    <div class="home-left"
         ref="homeLeft">
      <!--轮播图 -->
      <BannerCard ref="bannerCard"
                  :height="bannerHeight" />
      <!--常用模块 -->
      <CommonMenuCard />
    </div>
    <div class="home-right"
         ref="homeRight">
      <!--员工关怀卡片 -->
      <NoticeCard />
      <!--申请卡片 -->
      <div id="layout-work-flow-card"></div>
      <!--申请卡片 -->
      <!-- <WorkFlow ref="workFlow" /> -->
    </div>
  </div>
</template>

<script>
  // 员工关怀卡片
  import NoticeCard from './notice'
  // 常用模块
  import CommonMenuCard from './common-menu-card'
  // 轮播图
  import BannerCard from './banner'
  // 申请卡片
  // import WorkFlow from '@/flow/components/home-work-flow/index.vue'

  export default {
    name: 'home',
    components: {
      NoticeCard,
      CommonMenuCard,
      BannerCard,
      // WorkFlow
    },
    data () {
      return {
        height: 770,
        bannerHeight: 242, // 轮播图高度，需要动态计算来保证图片的展示
        flowHomeWork: null
      }
    },
    mounted () {
      this.handleResize()
      this.addResize()
      this.loadWorkFlow()
    },
    activated () {
      this.handleResize()
    },
    methods: {
      addResize () {
        window.onresize = this.handleResize
      },
      handleResize () {
        this.$nextTick(() => {
          this.height = this.$refs.homeRight ? this.$refs.homeRight.offsetHeight : 770
          const bannerHeight = this.$refs.homeLeft ? (this.$refs.homeLeft.offsetWidth - 25) / 3 : 242
          this.bannerHeight = bannerHeight
        })
      },
      // 加载首页流程组件-flow仓库远程组件
      loadWorkFlow () {
        const flowHomeWorkModule = new Promise(window.__ERP_REMOTE_IMPORT__('flow/FlowHomeWorkFlow'))
        flowHomeWorkModule.then(res => {
          let Ctor = this.$options._base.extend(res.default)
          this.flowHomeWork = new Ctor({ parent: this })
          this.flowHomeWork.$mount('#layout-work-flow-card')
        }).catch(console.log)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-home {
    background: #f2f3f7;
    display: flex;
    height: 100%;
    margin: 0px -16px -8px -16px;
    padding-top: 12px;
    padding-right: 16px;
    min-height: 100%;
    overflow-x: hidden;
    .home-left {
      padding: 0 9px 8px 16px;
      display: flex;
      flex-direction: column;
      width: 58.34%;
      padding-bottom: 8px;
      // flex: 1;
    }
    .home-right {
      width: 41.66%;
      min-width: 41.66%;
      padding-bottom: 8px;
      display: flex;
      flex-direction: column;
      // flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/index.vue